import { CommonIcons, icons } from "../../components/common/CommonIcons";

const navConfig = [
  {
    title: 'dashboard',
    path: 'dashboard',
    icon: <CommonIcons name={icons.dashboard} />
  },
  {
    title: 'products',
    path: '',
    icon: <CommonIcons name={icons.products} />,
    children: [
      {
        title: 'items',
        path: 'products',
      },
    ]
  },
  {
    title: 'sales',
    path: '',
    icon: <CommonIcons name={icons.sales} />,
    children: [
      {
        title: 'cashSales',
        path: 'documents/cashSales',
      },
      {
        title: 'deliveryOrders',
        path: 'documents/deliveryOrders',
      },
      {
        title: 'replacementDeliveries',
        path: 'documents/replacementDeliveries',
      },
    ]
  },
  {
    title: 'purchases',
    path: '',
    icon: <CommonIcons name={icons.purchase} />,
    children: [
      {
        title: 'purchaseReturns',
        path: 'documents/purchaseReturns',
      },
    ]
  },
  {
    title: 'warehouse',
    path: '',
    icon: <CommonIcons name={icons.warehouse} />,
    children: [
      {
        title: 'itemReceives',
        path: 'documents/itemReceives',
      },
      {
        title: 'itemTransfers',
        path: 'documents/itemTransfers',
      },
      {
        title: 'itemRelocates',
        path: 'documents/itemRelocates',
      },
      {
        title: 'itemTransforms',
        path: 'documents/itemReceives',
      },
      {
        title: 'stockTakes',
        path: 'documents/stockTakes',
      },
    ]
  },
  {
    title: 'logistics',
    path: '',
    icon: <CommonIcons name={icons.logistic} />,
    children: [
      {
        title: 'deliveryTrips',
        path: 'documents/tripOrders',
      },
    ]
  },
  {
    title: 'repositories',
    path: '',
    icon: <CommonIcons name={icons.repository} />,
    children: [
      {
        title: 'packages',
        path: 'repositories/packages'
      },
      {
        title: 'packPackages',
        path: 'repositories/package/pack'
      },
      {
        title: 'queryPackages',
        path: 'repositories/package/view'
      },
    ]
  },
  {
    title: 'operations',
    path: '',
    icon: <CommonIcons name={icons.operations} />,
    children: [
      {
        title: 'itemRelocateThreshold',
        path: 'operations/itemThreshold/relocate',
      },
      {
        title: 'examineInventory',
        path: 'operations/inventory/examine',
      },
    ]
  },
  // {
  //   title: 'Reports',
  //   path: '',
  //   icon: <CommonIcons name={icons.report} />,
  //   children:[
  //     {
  //       title: 'Sales',
  //       path: 'reports/sales',
  //     },
  //     {
  //       title: 'Cash Sales',
  //       path: 'reports/retailCashSales',
  //     },
  //     {
  //       title: 'Delivery',
  //       path: 'reports/delivery',
  //     },
  //     {
  //       title: 'Prescription',
  //       path: 'reports/retailPrescription',
  //     },
  //     {
  //       title: 'Item Receive',
  //       path: 'reports/itemReceive',
  //     },
  //   ]
  // },
];

export default navConfig;
